<p class="text-sm lg:text-xl text-black dark:text-white">{{ 'Matte' }}</p>
<mat-slide-toggle (change)="onChange($event)"> </mat-slide-toggle>
